const servicedata = {
  one: {
    name: "photography",
    title: "Hire professional photographers with ease",
    description: `Taking professional quality photographs with our team of photographers that are specifically chosen for your product. Everything is handled from composition, location, backdrops, models, hair and makeup to fit your vision perfectly. Retouching is done post production and included in your package.`,
    image:
      "https://ik.imagekit.io/euo36lugk/Nutrire/photo_LZL8VtH23.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677176362616",
  },
  two: {
    name: "brand management",
    title: "Managing your brand made easy",
    description: `Nutrire has the ability to handle your digital marketing needs including content creation, an influencer database, partnerships, collaborations, and sponsorships to fulfill your brands unique needs. Our team can assist with reaching your business objectives and reach your target audience.
`,
    image:
      "https://ik.imagekit.io/euo36lugk/Nutrire/image0__1__ZddEN5C4M.jpeg?updatedAt=1678609807570",
  },
  three: {
    name: "Product Management",
    title: "Product development",
    description: `Not sure where to start? Our team can assist you with cultivating the perfect brand for yourself or organization. With an extensive network of manufactures and clients, we have the ability to create your vision/product from the ground up.`,
    image:
      "https://ik.imagekit.io/euo36lugk/Nutrire/9_WLtXT6gqVF.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672607087341",
  },
  four: {
    name: "Web development",
    title: "Increase your online presence",
    description: `Nutrire management can assist with defining and increasing your online presence to match your values and goals. Our team is dedicated to help you to achieve your dreams through branding and direction.`,
    image:
      "https://ik.imagekit.io/euo36lugk/Nutrire/webdev_Z5wie2x3C.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1677176232566",
  },
  five: {
    name: "Makeup & Hair Artist",
    title: "We have hair and makeup artists from all over the United States.",
    description: `We offer hair and makeup services through a team of professionals located all over the United States. This allows us to provide a diverse range of styles and expertise to clients across different regions.`,
    image:
      "https://ik.imagekit.io/euo36lugk/Nutrire/annie-spratt-77rQJa2AKh0-unsplash_mE-2g8Rxe.jpg?updatedAt=1684616739580",
  },
};
export default servicedata;
